import { triggerAnalyticsEvent } from 'syf-js-utilities';
const triggerManageCardHoldersAnalytics = (params) => triggerAnalyticsEvent({
    pageFunction: 'auth user',
    pageKind: 'account services',
    pageSubFunction: 'manage cardholders',
    ...params
});
export default triggerManageCardHoldersAnalytics;
